import { useState, useEffect, useCallback } from 'react';
import { preferencesService, DashboardPreferences } from '@services/preferences.service';

export const useDashboardPreferences = () => {
  const [preferences, setPreferences] = useState<DashboardPreferences>(
    preferencesService.getPreferences()
  );

  useEffect(() => {
    const handlePreferencesChange = (event: CustomEvent<DashboardPreferences>) => {
      setPreferences(event.detail);
    };

    window.addEventListener(
      'dashboard-preferences-changed',
      handlePreferencesChange as EventListener
    );

    return () => {
      window.removeEventListener(
        'dashboard-preferences-changed',
        handlePreferencesChange as EventListener
      );
    };
  }, []);

  const updatePreferences = useCallback((updates: Partial<DashboardPreferences>) => {
    preferencesService.savePreferences(updates);
  }, []);

  const resetPreferences = useCallback(() => {
    preferencesService.resetPreferences();
  }, []);

  return {
    preferences,
    updatePreferences,
    resetPreferences,
  };
};
